module.exports = __webpack_public_path__ + "static/pic01-5d9992ae58b9042f10f52ec514ea4699.jpg";